import { render, staticRenderFns } from "./Fail.vue?vue&type=template&id=a74dde9c&scoped=true&"
import script from "./Fail.vue?vue&type=script&lang=js&"
export * from "./Fail.vue?vue&type=script&lang=js&"
import style0 from "./Fail.vue?vue&type=style&index=0&id=a74dde9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74dde9c",
  null
  
)

export default component.exports